import { config, SubscriptionService } from '..';
import {
  UPSERT_PAYMENT_SUCCESS,
  UPSERT_PAYMENT_FAILED,
  PROCEED_PAYMENT_SUCCESS,
  PROCEED_PAYMENT_FAILED,
} from '../../actionTypes';

export default (type, payload, token) => async (dispatch) => {
  try {
    let response;
    if (type === 'initial') {
      response = await SubscriptionService.put(
        '/payment/update-info',
        payload,
        config(token)
      );

      const {
        data: { message, data },
      } = response;
      dispatch({
        type: UPSERT_PAYMENT_SUCCESS,
        message,
        data,
      });
    }

    if (type === 'proceed') {
      response = await SubscriptionService.put(
        '/payment/update-info',
        payload,
        config(token)
      );

      const {
        data: { message, data },
      } = response;
      dispatch({
        type: PROCEED_PAYMENT_SUCCESS,
        message,
        data,
      });
    }
  } catch (err) {
    let error = {};
    if (err.response) {
      const {
        data: { status, message },
      } = err.response;
      error = { status, message };
    } else {
      error = {
        status: 500,
        message: err.message,
      };
    }
    if (type === 'initial') {
      dispatch({ type: UPSERT_PAYMENT_FAILED, error });
    }

    if (type === 'proceed') {
      dispatch({ type: PROCEED_PAYMENT_FAILED, error });
    }
  }
};
